(function () {
  if (window.__productSectionSpecTable) return;
  window.__productSectionSpecTable = true;

  function init(root) {
    if (!root || root.dataset.bound === 'true') return;
    var toggle = root.querySelector('[data-spec-toggle]');
    var groups = root.querySelector('[data-spec-groups]');
    var label = root.querySelector('[data-spec-toggle-label]');
    if (!toggle || !groups || !label) return;
    root.dataset.bound = 'true';

    toggle.addEventListener('click', function () {
      var open = groups.classList.toggle('is-open');
      toggle.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      label.textContent = open ? toggle.getAttribute('data-label-collapse') : toggle.getAttribute('data-label-expand');
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-product-section-spec-table]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
